// src/resources/properties/components/PropertyStatusChip.tsx
import { Box, Chip } from "@mui/material";
import { VisibilityOff, Block, CheckCircle } from "@mui/icons-material";
import { useRecordContext } from "react-admin";

export const PropertyStatusChip = () => {
  const record = useRecordContext();
  if (!record) return null;

  const getStatusChips = (property: Record<string, unknown>) => {
    const chips = [];

    if (property.deleted) {
      chips.push(
        <Chip
          key="deleted"
          label="Deleted"
          color="error"
          size="small"
          icon={<Block />}
        />,
      );
    } else if (property.closed) {
      chips.push(
        <Chip
          key="closed"
          label="Closed"
          color="warning"
          size="small"
          icon={<VisibilityOff />}
        />,
      );
    } else {
      chips.push(
        <Chip
          key="active"
          label="Active"
          color="success"
          size="small"
          icon={<CheckCircle />}
        />,
      );
    }

    return chips;
  };

  return <Box sx={{ display: "flex", gap: 0.5 }}>{getStatusChips(record)}</Box>;
};
